export default __webpack_public_path__ + "static/media/laptop12.b03dd42d.jpeg";